<div class="token-sale-page-container">
  <app-token-sale class="z-index--1"></app-token-sale>
  <app-circles-background class="circle-background"></app-circles-background>
</div>
